import React from 'react';
import { connect } from 'react-redux';
import { List } from 'react-toolbox/lib/list';
import {
  hideRemoveModulesDrawer,
  removeModulesDrawerDeselectAll,
  removeModulesDrawerModuleSelected,
  showRemoveModulesConfirmationDialog,
} from 'browse-media/redux/browseMediaActions';
import DrawerLayout from 'components/DrawerLayout';
import MediaAvatar from 'components/MediaAvatar';
import MediaIcon from 'components/MediaIcon';
import MediaListItem from 'components/MediaListItem';
import OverlayDrawer from 'components/OverlayDrawer';
import PanelLoadingIndicator from 'components/PanelLoadingIndicator';
import SelectionActionBar from 'components/SelectionActionBar';
import styles from 'browse-media/components/RemoveModulesDrawer.css';

const isIndeterminate = (module, selectedItemsModuleIdsIntersection) =>
  !selectedItemsModuleIdsIntersection.includes(module.id);

const RemoveModulesDrawer = ({
  mediaItems,
  modules,
  modulesLoaded,
  onClose,
  onRemoveModules,
  onRowSelect,
  onSelectionActionBarBack,
  selectedItemsModuleIdsIntersection,
  selectedMediaIds,
  selectedModuleIds,
  visible,
}) =>
  <OverlayDrawer active={visible} onClickBackdrop={onClose}>
    <DrawerLayout
      onClose={onClose}
      header={
        <div>
          {mediaItems.length === 1
            ? <div className={styles.itemsContainer}>
                <div className={styles.itemInfoContainer}>
                  <div className={styles.avatarContainer}>
                    <MediaAvatar media={mediaItems[0]}>
                      <MediaIcon
                        className={styles.mediaIcon}
                        media={mediaItems[0]}
                      />
                    </MediaAvatar>
                  </div>
                  <div className={styles.textContainer}>
                    <span className={styles.itemTitle}>
                      {mediaItems[0].name}
                    </span>
                    <span className={styles.itemSubTitle}>
                      {mediaItems[0].subName}
                    </span>
                  </div>
                </div>
                <div className={styles.modulesTextContainer}>
                  <h1 className={styles.modulesText}>
                    Item is currently in these modules...
                  </h1>
                </div>
              </div>
            : <div className={styles.itemsContainer}>
                <div className={styles.modulesTextContainer}>
                  <h1 className={styles.selectedItemsText}>
                    {selectedMediaIds.length} selected content items
                  </h1>
                </div>
                <div className={styles.modulesTextContainer}>
                  <h1 className={styles.modulesText}>
                    Modules in any of the selected items...
                  </h1>
                </div>
              </div>}
          {selectedModuleIds.length > 0 &&
            <SelectionActionBar
              selectedCount={selectedModuleIds.length}
              onBack={onSelectionActionBarBack}
              onRemove={onRemoveModules}
            />}
        </div>
      }
    >
      {modulesLoaded
        ? <List selectable ripple>
            {modules.map(module =>
              <MediaListItem
                indeterminate={isIndeterminate(
                  module,
                  selectedItemsModuleIdsIntersection,
                )}
                key={module.id}
                media={module}
                selected={selectedModuleIds.includes(module.id)}
                onSelected={onRowSelect}
              />,
            )}
          </List>
        : <PanelLoadingIndicator />}
    </DrawerLayout>
  </OverlayDrawer>;

const mapStateToProps = state => {
  const {
    selectedMediaIds,
    selectedItemsModuleIdsIntersection,
  } = state.browseMedia;

  const {
    mediaItems,
    modules,
    modulesLoaded,
    selectedModuleIds,
    visible,
  } = state.browseMedia.removeModulesDrawer;

  return {
    mediaItems,
    modules,
    modulesLoaded,
    selectedMediaIds,
    selectedModuleIds,
    selectedItemsModuleIdsIntersection,
    visible,
  };
};

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(hideRemoveModulesDrawer()),
  onRemoveModules: () => dispatch(showRemoveModulesConfirmationDialog(true)),
  onRowSelect: (selected, moduleId) =>
    dispatch(removeModulesDrawerModuleSelected(selected, moduleId)),
  onSelectionActionBarBack: () => dispatch(removeModulesDrawerDeselectAll()),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  RemoveModulesDrawer,
);
